import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";

import { useSite, useSites } from "@inrange/building-manager-api-client";
import Loading from "../Loading";

import { sortBy } from "@inrange/utils";
import { ReactNode, useState } from "react";
import SitesTable from "../SitesTable";
import SiteNav from "./siteSections/SiteNav";

const SiteScenarios: React.FC = () => {
  const { siteId } = useParams<{ siteId: string }>();
  const { fetchSite } = useSite({
    siteId,
    app: "admin",
  });
  const params = new URLSearchParams(window.location.search);
  const testOrgId = params.get("testOrgId");
  const sites = useSites(
    (fetchSite.data?.site?.nearbySiteIDs?.length ?? 0) > 0
      ? [siteId!, ...fetchSite.data!.site.nearbySiteIDs]
      : [],
    undefined,
    testOrgId
  );

  const [filteredLinkedOrgIds, setFilteredLinkedOrgIds] = useState<string[]>(
    []
  );
  const [tableAlertStyle, setTableAlertStyle] = useState<string>("secondary");
  const [tableAlertMessage, setTableAlertMessage] = useState<
    ReactNode | string | undefined
  >(undefined);

  const anySitesLoading = sites
    .map((orgSite) => orgSite.isLoading)
    .some((bool) => bool);

  if (fetchSite.isError) {
    return <div>Error loading the site.</div>;
  }

  if (fetchSite.isLoading || !fetchSite.data?.site) {
    return <Loading label="Loading site data..." />;
  }

  if (anySitesLoading) {
    return <Loading label={`Loading scenario site data...`} />;
  }

  const site = fetchSite.data?.site;

  document.title = `Site: ${site.name}`;

  const successfulSites = sites
    .filter((site) => site.isSuccess)
    .flatMap((site) => site.data?.sites);

  const filterOrgs = Array.from(
    new Map(
      successfulSites
        .flatMap((site) => site.siteOwnerships)
        .map((so) => [
          so.orgID,
          {
            name: so.name!,
            orgId: so.orgID,
          },
        ])
    ).values()
  ).sort(sortBy((so) => so.name));

  const filteredSites = successfulSites.filter(
    (site) =>
      filteredLinkedOrgIds.length === 0 ||
      site.siteOwnerships.some(
        (siteOwnership) =>
          filteredLinkedOrgIds.indexOf(siteOwnership.orgID) > -1
      )
  );

  return (
    <>
      <SiteNav />
      <Container fluid style={{ padding: "12px 12px 0px 12px" }}>
        <div style={{ padding: "0 0 12px 0", fontSize: "26px" }}>
          {site.name}
        </div>
        <SitesTable
          sites={filteredSites}
          thisSiteId={siteId!}
          filterOrgs={filterOrgs}
          orgFilterLabel={"organisation"}
          setFilteredLinkedOrgIds={setFilteredLinkedOrgIds}
          tableAlertStyle={tableAlertStyle}
          setTableAlertStyle={setTableAlertStyle}
          tableAlertMessage={tableAlertMessage}
          setTableAlertMessage={setTableAlertMessage}
          defaultSortOrder="created"
          defaultSortDirection="Desc"
        />
      </Container>
    </>
  );
};

export default SiteScenarios;
